import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../components/Home.vue'
import AboutView from '../views/AboutView.vue'
import LoginPage from '../components/Login.vue'
import RegisterPage from '../components/Register.vue'
import MainPage from '../components/Main.vue'
import OrgsPage from '../components/Orgs.vue'
import AddOrg from '../components/AddOrg.vue'
import SingleOrg from '../components/SingleOrg.vue'
import EditOrg from '../components/EditOrg.vue'
import EventsPage from '../components/Events.vue'
import AddEvent from '../components/AddEvent.vue'
import SingleEvent from '../components/SingleEvent.vue'
import UserProfile from '../components/UserProfile.vue'
import Courses from '../components/Courses.vue'
import SingleCourse from '../components/SingleCourse.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/dashboard'
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    
    path: '/dashboard',
    name: 'Dashboard',
    component: HomePage,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: MainPage
      },
      {
        path: '/dashboard/orgs',
        name: 'Organization Profiles',
        component: OrgsPage
      },
      {
        path: '/dashboard/add-org',
        name: 'Add Organization Profile',
        component: AddOrg
      },
      {
        path: '/dashboard/orgs/:id',
        name: 'Organization Profile',
        component: SingleOrg
      },
      {
        path: '/dashboard/orgs/:id/edit',
        name: 'Edit Organization Profile',
        component: EditOrg
      },
      {
        path: '/dashboard/events',
        name: 'Events',
        component: EventsPage
      },
      {
        path: '/dashboard/add-event',
        name: 'Add Event',
        component: AddEvent
      },
      {
        path: '/dashboard/events/:id',
        name: 'Event',
        component: SingleEvent
      },
      {
        path: '/dashboard/user-profile',
        name: 'User Profile',
        component: UserProfile
      },
      {
        path: '/dashboard/courses',
        name: 'Courses',
        component: Courses
      },
      {
        path: '/dashboard/courses/:id',
        name: 'Course',
        component: SingleCourse
      }
    ],
      beforeEnter: (to, from, next) => {

      let theUser = localStorage.getItem('sjdifjsckdsjfosdf54520yyy');
      let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

      if (requiresAuth && !theUser){
        next('login');
      }
      else if (!requiresAuth && theUser)
        next('dashboard')
      else
        next()
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  }
]

const router = new VueRouter({
  base: 'shabaka/user/',
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = 'SCCU - ' + to.name;
  next();
});


export default router
